export default __webpack_public_path__ + "static/media/mainfeature_icon3.79badecf.png";